<template>
   <div class="switch-container">
      <label class="switch" :class="{'big': size === 'big','small': size === 'small','disabled': disabled}">
         <input 
            type="checkbox" 
            :checked="switch_checked"
            @change="handleSelect"
            :disabled="disabled"
         >
         <span class="slider" :class="type"></span>
      </label>
   </div>
</template>

<script>
import { oneOf } from '../utils/assist';

export default {
   name: "SwitchComponent",
   props: {
		checked: [Boolean,Number],
		disabled: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
         validator (value) {
            return oneOf(value, ['big', 'small', '']);
         },
			default: ''
		},
		type: {
			type: String,
         validator (value) {
            return oneOf(value, ['round', '']);
         },
			default: ''
		},
	},
   data() {
		return {
			switch_checked: this.checked,
		};
	},
   methods: {
		handleSelect(event) {
			this.$emit("change", event.target.checked);
		},
	},
   watch: {
		checked() {
			this.switch_checked = this.checked;
			this.$emit("change", this.switch_checked);
		},
		disabled() {
			this.switch_disabled = this.disabled;
		}
	},
   mounted(){

   }
}
</script>